import { render, staticRenderFns } from "./InvoiceHeaderComponent.vue?vue&type=template&id=d31e94b4&"
import script from "./InvoiceHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./InvoiceHeaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports